import { Box } from "@mui/system";
import { Grid, Skeleton } from "@mui/material";

const STEP_COLORS = ["#607D8B", "#E91E63", "#03A9F4"];

function FamilyCardSkeleton() {
  return (
    <Box
      sx={{
        border: "1px solid #0000001F",
        borderRadius: "4px",
        p: 1,
        backgroundColor: "#fff",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Skeleton width={120} height={20} />
        <Skeleton width={24} height={24} variant="circular" />
      </Box>
      <Skeleton width="60%" height={16} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={56} sx={{ mb: 1 }} />
      <Skeleton variant="rounded" height={56} />
    </Box>
  );
}

/** Placeholder that mirrors the Interface Detail step blocks while Q1/Q3 are loading. */
const InterfaceDetailSkeleton = () => {
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Grid container spacing={2}>
        {STEP_COLORS.map((color, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Box
              sx={{
                borderTop: `4px solid ${color}`,
                borderRadius: "5px 5px 0 0",
                backgroundColor: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
              }}
            >
              <Box
                sx={{
                  px: 1,
                  py: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #e5e5e5",
                }}
              >
                <Box>
                  <Skeleton width={80} height={20} />
                  <Skeleton width={60} height={14} />
                </Box>
                <Skeleton variant="rounded" width={130} height={36} />
              </Box>

              <Box sx={{ p: 1, background: "#FAFAFA" }}>
                <FamilyCardSkeleton />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InterfaceDetailSkeleton;
